import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Stack, Switch, TextField, Typography } from "@mui/material";
import SelectPlanoContas from "../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas";
import { useState } from "react";
import { useMutation } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import { TAtualizarConfiguracoesComercial } from "../../../../../types/mutations/geral/atualizar-configuracoes";
import { TConfigComercial, TConfigComercialContaTransitoria } from "../../../../../types/api/geral/configuracoes";

export default function DialogAddConfig({
    open,
    previousValue,
    onSubmit,
    handleClose,
}: DialogAddConfigProps) {


    const isEdit = !!previousValue?.conta_transitoria || !!previousValue?.condicao_pagamento

    const [planoContas, setPlanoContas] = useState<TConfigComercialContaTransitoria | null>(
        previousValue?.conta_transitoria ? {
            codigo_contabil: previousValue?.conta_transitoria.codigo_contabil,
            nome: previousValue?.conta_transitoria.nome,
            centro_custo: previousValue?.conta_transitoria.centro_custo || null
        } : null
    )
    const [condicaoPagamento, setCondicaoPagamento] = useState<string | null>(previousValue?.condicao_pagamento || null)
    const [possuiAcrescimo, setPossuiAcrescimo] = useState(previousValue?.possui_acrescimo || false);
    const [percentualAcrescimo, setPercentualAcrescimo] = useState<number | null>(previousValue?.percentual_acrescimo || null);

    //querie e mutation
    const { mutate: atualizarConfig, isLoading } = useMutation({
        mutationKey: 'atualizar-config-comercial-conta-transitoria',
        mutationFn: (inputs: TAtualizarConfiguracoesComercial) => axiosClient.post(`atualizar-configuracoes`, inputs),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao adicionar configuração!', { variant: 'error' });
        },
        onSuccess: () => {
            enqueueSnackbar('Atualização da configuração realizada com sucesso!', { variant: 'success' });
            onSubmit()
        }
    })

    const handleSubmit = () => {
        if (!planoContas || !condicaoPagamento || (possuiAcrescimo && !percentualAcrescimo)) {
            enqueueSnackbar('Preencha todos os campos!', { variant: 'warning' });
            return
        };

        const contaTransitoria: TConfigComercialContaTransitoria = {
            codigo_contabil: planoContas.codigo_contabil,
            nome: planoContas.nome,
            centro_custo: planoContas.centro_custo || null
        }


        atualizarConfig({
            chave: "comercial",
            valor: {
                conta_transitoria: contaTransitoria,
                condicao_pagamento: condicaoPagamento,
                possui_acrescimo: possuiAcrescimo ? true : false,
                percentual_acrescimo: possuiAcrescimo ? percentualAcrescimo : null
            }
        })
    }

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle>{isEdit ? "Editar" : "Adicionar"} configurações</DialogTitle>

            <DialogContent>
                <Stack my={1} spacing={2}>
                    <Typography><b>Conta transitória</b></Typography>
                    <SelectPlanoContas
                        value={planoContas}
                        inputLabel="Conta transitória"
                        onChangeValue={(value) => {
                            const contaTransitoria: TConfigComercialContaTransitoria = {
                                codigo_contabil: value.codigo_contabil,
                                nome: value.nome,
                                centro_custo: value.centro_custo || null
                            }
                            setPlanoContas(contaTransitoria)
                        }}
                        extraParams={{ tipo: "Analítica" }}
                    />
                    <Divider />
                    <Typography><b>Condição de pagamento</b></Typography>
                    <TextField
                        label="Condição de pagamento"
                        value={condicaoPagamento}
                        onChange={(e) => setCondicaoPagamento(e.target.value)}
                        fullWidth
                    />
                    <Divider />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={possuiAcrescimo}
                                onChange={() => setPossuiAcrescimo((prev) => !prev)}
                            />
                        }
                        label="Aplicar acréscimo de percentual?"
                        sx={{ mb: 2 }}
                    />
                    {
                        possuiAcrescimo && (
                            <TextField
                                label="Percentual de acréscimo"
                                type="number"
                                slotProps={{ input: { endAdornment: <span>%</span> } }}
                                fullWidth
                                value={percentualAcrescimo || ""}
                                onChange={(e) => {
                                    const value = e.target.value ? parseFloat(e.target.value) : null;
                                    setPercentualAcrescimo(value);
                                }}
                            />
                        )
                    }
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={handleClose}
                >
                    Cancelar
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={isLoading}
                >
                    {isLoading && <CircularProgress size={20} sx={{ mr: 1 }} />}
                    {isEdit ? "Editar" : "Adicionar"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogAddConfigProps {
    open: boolean;
    handleClose: () => void;
    onSubmit: () => void;
    previousValue: TConfigComercial | null;
}
